import React from 'react';
import get from 'lodash/get';

class EmoticonsButton extends React.Component {
  render() {
    return (
      <a
        onClick={this.props.toggleEmoticonsPanel}
        className="btn btn--small btn--light btn--iconLeft emoticons-btn mrm"
      >
        <span className="btn-text">{get(translations, 'txt: Smaidiņi', '')}</span>
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <img src={`${get(globals, 'staticImageUri', '/')}smiley.png`} />
            </span>
          </span>
        </span>
      </a>
    );
  }
}

module.exports = EmoticonsButton;
